import { render, staticRenderFns } from "./NewsletterAccountUpdate.vue?vue&type=template&id=5dd55e67&scoped=true"
import script from "./NewsletterAccountUpdate.vue?vue&type=script&lang=js"
export * from "./NewsletterAccountUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd55e67",
  null
  
)

export default component.exports